import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { fetchDeliveryAddresses } from "../api/deliveryAddresses";
import MultiSelectChips from "./MultiSelectChips";
import type { MultiSelectOption } from "./MultiSelectChips";

type Props = {
  value: string[];
  onChange: (next: string[]) => void;
};

// Dünner Wrapper über `MultiSelectChips`, lädt die Adress-Facette einmalig
// (1000er-Limit, 5 Min stale) und mappt sie auf das generische Option-Format.
export default function DeliveryAddressMultiSelect({ value, onChange }: Props) {
  const listQuery = useQuery({
    queryKey: ["delivery-addresses", "all"],
    queryFn: () => fetchDeliveryAddresses({ limit: 1000 }),
    staleTime: 300_000,
  });

  const options = useMemo<MultiSelectOption[]>(() => {
    return (listQuery.data?.items ?? []).map((item) => ({
      key: item.delivery_address_key,
      label: item.delivery_address_display ?? item.delivery_address_key,
      searchText: `${item.delivery_address_display ?? ""} ${item.delivery_address_key}`,
      badge: item.is_warehouse ? (
        <span className="rounded bg-amber-100 px-1 text-[10px] text-amber-700">
          Lager
        </span>
      ) : null,
      secondary: item.line_count ?? 0,
    }));
  }, [listQuery.data]);

  return (
    <MultiSelectChips
      value={value}
      onChange={onChange}
      options={options}
      isLoading={listQuery.isLoading}
      placeholder="Lieferadresse suchen …"
    />
  );
}
